export const isSameHighlight = (a, b) => {
    if (a.length === b.length) {
        return containHighlight(a, b);
    }
    return false;
};
export const containHighlight = (a, b) => {
    for (const newHighlightObj of a) {
        if (!b.some((currentHighlightObj) => currentHighlightObj.layerId === newHighlightObj.layerId &&
            currentHighlightObj.featureId === newHighlightObj.featureId)) {
            return false;
        }
    }
    return true;
};
//# sourceMappingURL=highlight.js.map